import { createClient } from '@/shared/api';
import UPDATE_MORPHOLOGY from '@/entities/beat/api/mutations/updateMorphology';
import type {
  UpdateMorphologyMutation,
  UpdateMorphologyMutationVariables,
} from '@/shared/api/generated/graphql';

export type UpdateMorphologyResult = {
  isSuccess: boolean;
  message: string;
};

// TODO(ts): typed as the UpdateMorphologyInput GraphQL input once its server-side shape is documented
/**
 * Saves changes made to a beat morphology group. Runs the updateMorphology mutation and returns its field, tolerating a nullish response.
 *
 * @param input - Mutation input carrying the morphology changes.
 * @returns A promise resolving to the updateMorphology result.
 */
const handleUpdateMorphology = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<UpdateMorphologyMutation, UpdateMorphologyMutationVariables>({
    mutation: UPDATE_MORPHOLOGY,
    variables: { input },
  });
  const { data } = result || {};
  const { updateMorphology } = data || {};
  return updateMorphology;
};

export default handleUpdateMorphology;
